<template>
  <div>
        <b-modal
            centered
            hide-footer
            v-model="modalExport"
            @close="onClose"
        >
            <template slot="modal-title">
              <div slot="header" class="bg-white border-0 ">
                <div class="row align-items-center">
                  <div class="col-12">
                    <h3 class="mb-0">
                      Export
                    </h3>
                  </div>
                </div>
              </div>
            </template>
            <template slot="default">
                <div>
                    <base-input
                        formClasses="mb-0"
                        alternative
                        label="ข้อมูลประจำวันที่"
                        typeInput="date"
                        placeholder="dd/mm/yyyy"
                        size="lg"
                        v-model="search.date"  
                    />
                </div>
                <div class="mt-3">
                    <label for="">ประเภทไฟล์</label>
                    <base-checkbox class="custom-control-alternative" @input="onChangeCheckbox($event,'xlsx')">
                        <span class="">ไฟล์ Excel (.xlsx)</span>
                    </base-checkbox>
                    <base-checkbox class="custom-control-alternative" @input="onChangeCheckbox($event,'xlsx')">
                        <span class="">ไฟล์สำหรับอัพโหลดให้ธนาคาร (.txt)</span>
                    </base-checkbox>
                </div>
                <div class="mt-2">
                    <label for="">ประเภทการอัพโหลดไฟล์ธนาคาร</label>
                    <base-checkbox class="custom-control-alternative" @input="onChangeCheckbox($event,'xlsx')">
                        <span class="">ธนาคารเดียวกัน (SCB)</span>
                    </base-checkbox>
                    <base-checkbox class="custom-control-alternative" @input="onChangeCheckbox($event,'xlsx')">
                        <span class="">ไฟล์สำหรับอัพโหลดให้ธนาคาร (.txt)</span>
                    </base-checkbox>
                </div>
                <div class="mt-2">
                    <button type="button" class="btn btn-warning" @click="ExportFile()">Export</button>
                </div>
            </template>
        </b-modal>
    </div>
</template>

<script>
import baseInput from '@/components/BaseInput.vue'
import { exportTransaction } from "@/axios/shop.js"
import fileDownload from 'js-file-download';
const API_URL = process.env.VUE_APP_API
export default {
    components: {
        baseInput
    },
    props: {
        modalExport: Boolean,
        search: Object,
        load: Boolean,
        fileName: String,
        DATE_NOW: String,
    },
    data () {
        return {
            typeUpload: {
                xlsx: false,
                txt: false,
                sameBank: false,
                uploadForBank: false,
            },
        }
    },
    methods: {
        onChangeCheckbox($e,val) {
            console.log('$e', $e)
            this.typeUpload[val] = !this.typeUpload[val]
        },
        onClose() {
            this.$emit('close', 'Export')
        },
        ExportFile() {
            // this.load = true;
            const body = {
                date_time_transfer: this.search.date,
                typeUpload: this.typeUpload,
            }
            this.$http.get( API_URL + "/shippop/export/managecod" , body, {
                headers: {
                    Token: localStorage.getItem("access_token")
                }
            }).then( res => {
                this.listShop = res.data.data
            })
                // fileDownload(res, `${this.fileName}-${this.DATE_NOW}.xlsx`);
                // this.load = false;
        }
    },
}
</script>